export function MongodbIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="26" 
        height="56" 
        viewBox="0 0 26 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M13.83 56.0001L12.328 55.5021C12.328 55.5021 12.528 47.9021 9.77807 47.3681C7.9781 45.2721 9.92013 -42.1847 16.5 47C15.2516 47.6333 14.4203 48.7948 13.958 50.1161C13.7102 52.0676 13.6673 54.0397 13.83 56.0001Z" 
          fill="url(#paint0_linear_mongodb)" 
        />
        <path 
          d="M14.6418 48.6584C18.6409 45.6479 21.7035 41.5642 23.4736 36.882C25.2438 32.1999 25.6488 27.1114 24.6416 22.2082C21.7017 9.23807 14.7398 4.97403 13.9898 3.34602C13.3427 2.33227 12.7904 1.26107 12.3398 0.145996L12.8938 36.2843C12.8938 36.2843 11.7459 47.3284 14.6418 48.6584Z" 
          fill="url(#paint1_linear_mongodb)" 
        />
        <path 
          d="M11.5633 49.1384C11.5633 49.1384 -0.67842 40.8003 0.0295665 26.0502C0.0956103 21.6035 1.11515 17.2227 3.01933 13.2037C4.92351 9.18481 7.66798 5.62134 11.0674 2.75402C11.4646 2.41651 11.7802 1.99337 11.9905 1.51637C12.2007 1.03938 12.3002 0.52094 12.2813 0C13.0433 1.64001 12.9193 24.4862 12.9993 27.1582C13.3093 37.5523 12.4213 47.1764 11.5633 49.1384Z" 
          fill="url(#paint2_linear_mongodb)" 
        />
        <defs>
          <linearGradient 
            id="paint0_linear_mongodb" 
            x1="3.73372" 
            y1="28.5044" 
            x2="20.9968" 
            y2="34.3624" 
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.231" stopColor="#999875"/>
            <stop offset="0.563" stopColor="#9B9977"/>
            <stop offset="0.683" stopColor="#A09F7E"/>
            <stop offset="0.768" stopColor="#A9A889"/>
            <stop offset="0.837" stopColor="#B7B69A"/>
            <stop offset="0.896" stopColor="#C9C7B0"/>
            <stop offset="0.948" stopColor="#DEDDCB"/>
            <stop offset="0.994" stopColor="#F8F6EB"/>
            <stop offset="1" stopColor="#FBF9EF"/>
          </linearGradient>
          <linearGradient 
            id="paint1_linear_mongodb" 
            x1="10.0638" 
            y1="-0.112234" 
            x2="17.6961" 
            y2="47.546" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#48A547"/>
            <stop offset="1" stopColor="#3F9143"/>
          </linearGradient>
          <linearGradient 
            id="paint2_linear_mongodb" 
            x1="-1.02347" 
            y1="27.5103" 
            x2="19.4575" 
            y2="20.6514" 
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#41A247"/>
            <stop offset="0.352" stopColor="#4BA74B"/>
            <stop offset="0.956" stopColor="#67B554"/>
            <stop offset="1" stopColor="#69B655"/>
          </linearGradient>
        </defs>
      </svg>
    )
  }